// extracted by mini-css-extract-plugin
export default {"modal":"wja-z","header":"xja-z","fields":"yja-z","error":"zja-z","disabled":"Aja-z","reminderMsg":"Bja-z","errorMsg":"Cja-z","footer":"Dja-z"};